var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:_vm.verticalOrientationCheck},_vm._l((_vm.offers),function(offer){return _c('OffersCard',{key:offer.offerCode,attrs:{"offer":offer}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }